'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./search/search'));
    processInclude(require('sunnie_foods/product/wishlistHeart'));
    processInclude(require('pluggin_variable_weight/product/tile'));
});
